import { render, staticRenderFns } from "./UpsertAdhocCategory.vue?vue&type=template&id=cbef4ac8&scoped=true"
import script from "./UpsertAdhocCategory.vue?vue&type=script&lang=js"
export * from "./UpsertAdhocCategory.vue?vue&type=script&lang=js"
import style0 from "./UpsertAdhocCategory.vue?vue&type=style&index=0&id=cbef4ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef4ac8",
  null
  
)

export default component.exports